import classnames from 'classnames/bind';
import { InternalLink } from '../../../InternalLink';
import { HOME_PATH } from '../../../RouteList';
import { Logo } from './Logo';
import { LogoCaption } from './LogoCaption';
import styles from './NavigationSideBarLogo.module.scss';

const classNameBuilder = classnames.bind(styles);

export const NavigationSideBarLogo = ({ collapsed }) => (
    <InternalLink path={HOME_PATH} aria-label="Taboola Ads Logo">
        <div className={classNameBuilder('container')}>
            <div className={classNameBuilder('icon', { collapsed })}>
                <Logo />
            </div>
            <div className={classNameBuilder('label', { collapsed })}>
                <LogoCaption />
            </div>
        </div>
    </InternalLink>
);
